import { render } from "./error.vue?vue&type=template&id=1e580e65&scoped=true"
import script from "./error.vue?vue&type=script&lang=js"
export * from "./error.vue?vue&type=script&lang=js"

import "./error.vue?vue&type=style&index=0&id=1e580e65&lang=scss&scoped=true"

import exportComponent from "/var/www/html/neo-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e580e65"]])

export default __exports__